var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPddopp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 89.3 120",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main lighter",
    vectorEffect: "non-scaling-stroke",
    d: "M18.1 53.8v12.5s9.9 1.4 9.9-6.5c0 0-.4-7.7-9.9-6zM2.4 53.8v12.5s9.9 1.4 9.9-6.5c-.1 0-.4-7.7-9.9-6zM45.4 66.4V53.9c10.4-1.4 9.9 3.4 9.9 3.4s.7 3.8-8.6 3.5M61.2 66.4V53.9c10.4-1.4 9.9 3.4 9.9 3.4s.7 3.8-8.6 3.5M76.9 66.3V53.7c10.4-1.4 9.9 3.4 9.9 3.4s.7 3.9-8.6 3.6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "IC_4L_main lighter",
    vectorEffect: "non-scaling-stroke",
    cx: 36.7,
    cy: 63.4,
    rx: 3.5,
    ry: 3.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPddopp);
export default __webpack_public_path__ + "static/media/PDDOPP.f6417898f370f4fb9ee7debd7e194172.svg";
export { ForwardRef as ReactComponent };